import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ensureMeta } from '../../shared/actions/meta';

// {host}/record/saved/{collection_id}

class RecordSaved extends Component {
    componentWillMount() {
        let id = this.props.match.params.collectionId;
        this.props.dispatch(ensureMeta(id));
    }

    render() {
        let customMessage = null;

        if (this.props.successMessage) {
            customMessage = <div dangerouslySetInnerHTML={{__html: this.props.successMessage}}></div>
        }

        return <div className="ac-wizard">
            <div className="ac-wizard-header">
                <h2>Thank you!</h2>
            </div>

            <div className="ac-wizard-body">
                <p>Your {this.props.recordLabel} was saved successfully.</p>
                {customMessage}
                <p>You may now close your browser.</p>
            </div>
        </div>
    }
}

function mapStateToProps(state) {
    var recordLabel = 'entry';
    if (state.meta && state.meta.friendlyName) {
        recordLabel = state.meta.friendlyName;
    }

    return {
        recordLabel: recordLabel,
        successMessage: state.meta ? state.meta.successMessage : 'foo'
    };
}

export default connect(mapStateToProps)(RecordSaved);